import { Axios } from "../utils/axios";

// 获取列表

export const getList = params => {
  return Axios.get("/trainAdmin/examinationAdmin/list?" + params);
};
// 新增;
export const createInfo = data => {
  return Axios.post("/trainAdmin/examinationAdmin", data);
};
// 编辑
export const editInfo = data => {
  return Axios.put("/trainAdmin/examinationAdmin", data);
};
// 删除;
export const deleteInfo = id => {
  return Axios.delete(`/trainAdmin/examinationAdmin/${id}`);
};
// 单条信息;
export const getInfo = id => {
  return Axios.get(`/trainAdmin/examinationAdmin/${id}`);
};
// 已上架实操试卷列表
export const practicalPaperList = () => {
  return Axios.get(`/trainAdmin/questionPracticalPaper/publish/list`);
};
export const getExamAll = () => {
  return Axios.get(`/trainAdmin/questionMemberInfo/allExamination`);
};

// 生成试卷
export const generateStartExamPaper = params => {
  return Axios.get(`/trainAdmin/generatePaper/generateStartExamPaper`, {
    params,
    timeout: 1000 * 5 * 60
  });
};
// 生成实操成绩
export const practicalScoreHandel = params => {
  return Axios.post(`/trainAdmin/practicalScoreSync/sync`, params);
};
// 生成理论成绩
export const theoryScoreHandel = params => {
  return Axios.post(`/trainAdmin/theoryScoreSync/sync`, params);
};

// 简答题评分获取题目
export const getShortQsData = params => {
  return Axios.get(`/trainAdmin/practicalShortAnswerScore/listUnscored`, {
    params
  });
};
// 简答题评分 提交
export const handleShortQs = params => {
  return Axios.post(`/trainAdmin/practicalShortAnswerScore/batchScore`, params);
};



// WEBPACK FOOTER //
// ./src/api/exam.js